module.exports = __webpack_public_path__ + "images/externallinkicon4.svg";